import type { Enum } from '@partou/core';

export const OBSERVATION_ORIGINS = ['automatic', 'group', 'manager'] as const;

export type ObservationOrigin = Enum<typeof OBSERVATION_ORIGINS>;
